import TagManager from 'react-gtm-module'

import { AnalyticsContext } from '../types/analytics'

export type LoginMethod = 'password' | 'email_link'

export interface SwitchLoginMethodParams {
  context: AnalyticsContext
  toMethod: LoginMethod
}

const switchLoginMethod = ({ context, toMethod }: SwitchLoginMethodParams) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'switch_login_method',
      context: `${context}_to_${toMethod}`,
    },
  })
}

export default switchLoginMethod
